import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import { PAGE_TITLES } from "../../utils/Enum";

const BreadCrumbs = (props: { breadcrumb?: string }): ReactElement => {
  return (
    <nav
      className="flex mt-[120px] mx-[50px] bg-gray-200"
      aria-label="Breadcrumb"
    >
      <ol className="inline-flex space-x-1 text-gray-950 md:space-x-2 rtl:space-x-reverse">
        <li className="inline-flex items-center">
          <div className="icon-home text-xl pr-2" />
          <Link
            to="/"
            id="searchPageHome"
            className="items-center hover:text-blue light:text-gray-950 dark:bg-gray-800 dark:text-gray-400 dark:hover:text-white"
          >
            <div className="text-md">{PAGE_TITLES.HOME}</div>
          </Link>
        </li>
        <li>
          <div className="flex items-center">
            <div className="icon-chevron_right text-2xl" />
            <Link
              id={PAGE_TITLES.ADMINPORTAL}
              to="/admin"
              className="ms-1 text-md font-normal hover:hover:text-[#005DAB] md:ms-2 dark:text-gray-600 dark:hover:text-white h-[19px]"
            >
              {PAGE_TITLES.ADMINPORTAL}
            </Link>
          </div>
        </li>
        {props.breadcrumb ? (
          <li>
            <div className="flex items-center">
              <div className="icon-chevron_right text-2xl" />
              <Link
                id="archivePortal"
                to="/admin/archive"
                className="ms-1 text-md font-normal hover:hover:text-[#005DAB] md:ms-2 dark:text-gray-400 dark:hover:text-white h-[19px]"
              >
                {props.breadcrumb}
              </Link>
            </div>
          </li>
        ) : (
          <></>
        )}
      </ol>
    </nav>
  );
};

export default BreadCrumbs;
